// extracted by mini-css-extract-plugin
export default {"smallDropdownIcon":"invoices_smallDropdownIcon__ICGBK","smallButtonText":"invoices_smallButtonText__DaSD6"};